/**
 * JWT helper utilities for decoding token payloads.
 *
 * Used by App.js (rehydration check) and ImpersonationBanner (countdown timer)
 * to read token expiration without a full JWT library.
 */

/**
 * Decode a JWT and return the expiration timestamp in milliseconds.
 *
 * @param {string} token - A signed JWT string (header.payload.signature)
 * @returns {number|null} Expiration time in ms since epoch, or null if the
 *   token is missing, malformed, or has no `exp` claim.
 */
export function decodeJwtExpiration(token) {
	if (!token) return null;

	try {
		const base64Url = token.split('.')[1];
		if (!base64Url) return null;

		const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
		const jsonPayload = decodeURIComponent(
			atob(base64)
				.split('')
				.map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
				.join('')
		);
		const payload = JSON.parse(jsonPayload);

		if (!payload.exp) return null;

		// JWT `exp` is in seconds; convert to milliseconds
		return payload.exp * 1000;
	} catch (error) {
		console.error('Failed to decode JWT expiration:', error);
		return null;
	}
}
